/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Size_LengthInputs */

const en_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size / Length`)
};

const es_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño / Longitud`)
};

const fr_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille / Longueur`)
};

const de_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe / Länge`)
};

const ja_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズ / 長さ`)
};

const zh_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尺寸 / 长度`)
};

const ar_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المقاس / الطول`)
};

const id_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran / Panjang`)
};

const it_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misura / Lunghezza`)
};

const ru_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер / Длина`)
};

const pt_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho / Comprimento`)
};

const ko_field_size_length = /** @type {(inputs: Field_Size_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크기 / 길이`)
};

/**
* | output |
* | --- |
* | "Size / Length" |
*
* @param {Field_Size_LengthInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_size_length = /** @type {((inputs?: Field_Size_LengthInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Size_LengthInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_size_length(inputs)
	if (locale === "es") return es_field_size_length(inputs)
	if (locale === "fr") return fr_field_size_length(inputs)
	if (locale === "de") return de_field_size_length(inputs)
	if (locale === "ja") return ja_field_size_length(inputs)
	if (locale === "zh") return zh_field_size_length(inputs)
	if (locale === "ar") return ar_field_size_length(inputs)
	if (locale === "id") return id_field_size_length(inputs)
	if (locale === "it") return it_field_size_length(inputs)
	if (locale === "ru") return ru_field_size_length(inputs)
	if (locale === "pt") return pt_field_size_length(inputs)
	return ko_field_size_length(inputs)
});